// extracted by mini-css-extract-plugin
export default {"container":"CreateJobTagsTab_container__6N3RY","title":"CreateJobTagsTab_title__aEOwx","formFooter":"CreateJobTagsTab_formFooter__a5x1t"};